'use client';

import Link from 'next/link';
import { Button } from '@/components/ui/button';
import { CheckCircle2, ArrowRight, Phone, Mail } from 'lucide-react';
import { DEFAULT_IMAGES, CONTACT } from '@/lib/constants';
import { SERVICES } from '@/lib/services-data';
import { useEffect, useState } from 'react';
import { fetchServicesData } from '@/lib/api';

export default function ServicePageClient() {
    const [services, setServices] = useState([]);

    useEffect(() => {
      const initLoad = async () => {
          const fetchProduct = await fetchServicesData();
          setServices(fetchProduct);
      }
      initLoad();
    }, [])
  return (
    <>
      {/* Solutions Grid */}
      <section className="px-4 py-16 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-7xl">
          <div className="grid gap-8 sm:grid-cols-1 lg:grid-cols-3">
            {services.map((service: any) => {
              return (
                <div
                  key={service.id}
                  className="bg-white border border-slate-200 rounded-2xl overflow-hidden hover:shadow-xl transition-all duration-300 flex flex-col"
                >
                  {/* Image Header */}
                  <div className="relative overflow-hidden h-[260px]">
                    <img
                      src={service.image.medium}
                      alt={service.name}
                      className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                    <div className="absolute bottom-4 left-4 flex items-center gap-3">
                      <h3 className="text-white font-bold text-base">
                        {service.name}
                      </h3>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-6 flex flex-col flex-grow">
                    <p className="text-muted-foreground text-sm leading-relaxed mb-5">
                      {service.description}
                    </p>

                    {/* Features List */}
                    <div className="space-y-3 flex-grow">
                      {service.features?.slice(0, 5).map((feature: string) => (
                        <div key={`service.features.${feature}`} className="flex items-start gap-3">
                          <CheckCircle2 className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" />
                          <span className="text-sm text-slate-600">{feature}</span>
                        </div>
                      ))}
                    </div>

                    {/* CTA Button */}
                    <Link href={`/dich-vu/${service.slug}`}>
                      <Button className="w-full mt-6 bg-primary text-white hover:bg-primary/90 flex items-center justify-center gap-2 h-10 font-semibold text-sm">
                        Xem Chi Tiết <ArrowRight className="h-4 w-4" />
                      </Button>
                    </Link>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="px-4 py-20 sm:px-6 lg:px-8 bg-primary">
        <div className="mx-auto max-w-7xl">
          <div className="mb-16 text-center">
            <h2 className="text-4xl font-bold text-white mb-4">Quy Trình Làm Việc</h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Chúng tôi tuân theo quy trình nghiêm ngặt để đảm bảo chất lượng và thành công của dự án
            </p>
          </div>
          <div className="grid gap-8 sm:grid-cols-1 lg:grid-cols-4">
            {[
              { step: '01', title: 'Tư Vấn', description: 'Hiểu rõ nhu cầu và thách thức của bạn' },
              { step: '02', title: 'Thiết Kế', description: 'Lên kế hoạch chi tiết và xác định giải pháp' },
              { step: '03', title: 'Triển Khai', description: 'Xây dựng và triển khai hệ thống' },
              { step: '04', title: 'Hỗ Trợ', description: 'Hỗ trợ liên tục và tối ưu hóa' }
            ].map((item, idx) => (
              <div key={idx} className="bg-white border border-slate-200 rounded-xl p-8 text-center">
                <div className="bg-blue-50 text-primary w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 text-2xl font-bold">
                  {item.step}
                </div>
                <h3 className="text-xl font-bold text-foreground mb-2">{item.title}</h3>
                <p className="">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

    </>
  );
}
